import React, { useState } from "react";
import { Carousel } from 'react-responsive-carousel';

import "./Partnership.css";

const ImageLink = ({ link, img, text, partner }) => (
<div className="column w-1/6 flex justify-center">
    <a href={link} target="_blank" rel="noreferrer">
      <p className="text-white text-xs text-center">{partner}</p>
      <img
        src={require(`../../Assets/Partner2023/${img}.png`)}
        alt={text}
      />
    </a>
    </div>
);

const Partnership = () => {
  const [currentSlide, setCurrentSlide] = useState(1);


  const updateCurrentSlide = (index) => {
      if (currentSlide !== index) {
        setCurrentSlide(index);
      }
  };

  return (
    <>
      <div className="container-2 px-10 hidden md:block">
        <div className="row flex justify-between items-center w-full py-10">
          <ImageLink link="https://linktr.ee/bigaproductions" img="Big_A_Transparent" text="Big A Productions" partner="Official Production Partner" />
          <ImageLink link="https://www.instagram.com/mybugabuga/" img="Buga_blue_logo" text="Buga Buga Burger" partner="Official Cuisine Partner" />
          <ImageLink link="https://instagram.com/countryfarm.organics?igshid=MzRlODBiNWFlZA" img="country_farm_organics" text="Country Farm Organics" partner="Official Nutrition Partner" />
          <ImageLink link="https://linktr.ee/laneigemy" img="laneige" text="Laneige" partner="Official Beauty Partner" />
          <ImageLink link="https://www.instagram.com/quintagen.official" img="quintagen" text="Quintagen" partner="Official Tech Partner" />
        </div>
      </div>
      <div className="container-2  md:hidden">
        <Carousel
          infiniteLoop
          autoPlay
          swipeable
          stopOnHover
          interval={20000}
          showIndicators={false}
          showThumbs={false}
          showStatus={false}
          selectedItem={currentSlide}
          onChange={updateCurrentSlide}
        >
          <ImageLink link="https://linktr.ee/bigaproductions" img="Big_A_Transparent" text="Big A Productions" partner="Official Production Partner" />
          <ImageLink link="https://www.instagram.com/mybugabuga/" img="Buga_blue_logo" text="Buga Buga Burger" partner="Official Cuisine Partner" />
          <ImageLink link="https://instagram.com/countryfarm.organics?igshid=MzRlODBiNWFlZA" img="country_farm_organics" text="Country Farm Organics" partner="Official Nutrition Partner" />
          <ImageLink link="https://linktr.ee/laneigemy" img="laneige" text="Laneige" partner="Official Beauty Partner" />
          <ImageLink link="https://www.instagram.com/quintagen.official" img="quintagen" text="Quintagen" partner="Official Tech Partner" />
        </Carousel>
      </div>
    </>
  );
};

export default Partnership;
